import script from "./lista-oportunitys.vue?vue&type=script&setup=true&lang=js"
export * from "./lista-oportunitys.vue?vue&type=script&setup=true&lang=js"

import "./lista-oportunitys.vue?vue&type=style&index=0&id=67201bb2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67201bb2"]])

export default __exports__